import { ICON_COLOR, LogoutIcon } from '@zep-us/zus';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ChevronLeftIcon } from '@/icons';
import { useUser } from '@/lib/auth';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui';
import { Button } from '@/ui_v3';
import { ProfileIconButton } from './MobileDrawer/ProfileIconButton';
import { HeaderContainer } from './HeaderContainer';
const LANDING_PATHS = ['/lti/deep-linking', '/google-classroom'];

/**
 * 외부 플랫폼(Google Classroom, LTI) 환경에서 사용하는 간소화 GNB.
 * - 로고 클릭 비활성화
 * - 네비게이션 버튼, 공유, 햄버거 메뉴 모두 제거
 * - "ZEP Quiz" 브랜딩만 표시
 * - 랜딩 페이지가 아닌 곳에서는 뒤로가기 버튼 표시
 * - 프로필 아이콘 + 로그아웃 드롭다운 제공
 */
export function GnbHeaderForExternalPlatform() {
  const {
    t
  } = useTranslation(['common']);
  const router = useRouter();
  const {
    logOut
  } = useUser();
  const isLanding = LANDING_PATHS.includes(router.pathname);
  return <HeaderContainer data-sentry-element="HeaderContainer" data-sentry-component="GnbHeaderForExternalPlatform" data-sentry-source-file="GnbHeaderForExternalPlatform.tsx">
      <div className="flex items-center">
        {!isLanding && <Button variant="transparent" intent="neutral" size="sm" onClick={() => router.back()} className="mr-2xs">
            <ChevronLeftIcon size="xs" />
          </Button>}
        <span className="text-heading-sm-bold text-default">
          {t('lti.nav.zepQuiz')}
        </span>
      </div>
      <DropdownMenu modal={false} data-sentry-element="DropdownMenu" data-sentry-source-file="GnbHeaderForExternalPlatform.tsx">
        <DropdownMenuTrigger className="flex items-center rounded-sm focus:outline-none" data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="GnbHeaderForExternalPlatform.tsx">
          <ProfileIconButton data-sentry-element="ProfileIconButton" data-sentry-source-file="GnbHeaderForExternalPlatform.tsx" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[160px] rounded-sm px-xs py-3xs shadow-lg" data-sentry-element="DropdownMenuContent" data-sentry-source-file="GnbHeaderForExternalPlatform.tsx">
          <DropdownMenuItem onClick={() => logOut({
          redirectTo: '/landing'
        })} className="p-xs text-body-sm font-medium text-destructive hover:text-destructive focus:text-destructive" data-sentry-element="DropdownMenuItem" data-sentry-source-file="GnbHeaderForExternalPlatform.tsx">
            <LogoutIcon size="xs" fill={ICON_COLOR.destructive} data-sentry-element="LogoutIcon" data-sentry-source-file="GnbHeaderForExternalPlatform.tsx" />
            <span className="ml-2">{t('header.logout')}</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </HeaderContainer>;
}